import { Component, OnInit } from '@angular/core';
import { ISpecificBrickSettingsComponent } from '../../../../dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { CallHistoryBrowserSettingsState } from '../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/call-history-browser-settings/call-history-browser-settings.state';
import { map } from 'rxjs/operators';
import {
   CallHistoryChangeAutomaticFilteringOnIncomingCall,
   CallHistoryChangeRetainFilterOnCallFinish,
   CallHistoryChangeShowPrimaryFullDateFormat,
} from '../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/call-history-browser-settings/call-history-browser-settings.actions';

@Component({
   selector: 'samweb-call-history-browser-settings',
   templateUrl: './call-history-browser-settings.component.html',
   styleUrls: ['./call-history-browser-settings.component.scss'],
})
export class CallHistoryBrowserSettingsComponent implements OnInit, ISpecificBrickSettingsComponent {
   public brickInstanceId: string;
   public automaticFilteringOnIncomingCall$: Observable<boolean>;
   public retainFilterOnCallFinish$: Observable<boolean>;
   public showPrimaryFullDateFormat$: Observable<boolean>;

   constructor(private store: Store) {}

   ngOnInit() {
      this.automaticFilteringOnIncomingCall$ = this.store
         .select(CallHistoryBrowserSettingsState.getAutomaticFilteringOnIncomingCall)
         .pipe(map((fn) => fn(this.brickInstanceId)));
      this.retainFilterOnCallFinish$ = this.store
         .select(CallHistoryBrowserSettingsState.getRetainFilterOnCallFinish)
         .pipe(map((fn) => fn(this.brickInstanceId)));
      this.showPrimaryFullDateFormat$ = this.store
         .select(CallHistoryBrowserSettingsState.getShowPrimaryFullDateFormat)
         .pipe(map((fn) => fn(this.brickInstanceId)));
   }

   changeAutomaticFilteringOnIncomingCall(checked: boolean) {
      this.store.dispatch(new CallHistoryChangeAutomaticFilteringOnIncomingCall(this.brickInstanceId, checked));
   }

   changeRetainFilterOnCallFinish$(checked: boolean) {
      this.store.dispatch(new CallHistoryChangeRetainFilterOnCallFinish(this.brickInstanceId, checked));
   }

   changeShowPrimaryFullDateFormat$(checked: boolean) {
      this.store.dispatch(new CallHistoryChangeShowPrimaryFullDateFormat(this.brickInstanceId, checked));
   }
}
